import styled, { css } from 'styled-components';

export const MatchRowWrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.1em;
  min-height: 4em;
  width: 100%;
  padding: 0.5em 0;
  //margin: ${props => (props.isHighlight ? '0px' : '0 auto 0.4em')};
  border-bottom: 1px solid ${props => props.theme.colors.gray};
  background: ${props => (props.isLastmatch ? props.theme.colors.teamCalendarLastColor : 'initial')};
  text-decoration: none;
  &.no-event{
    pointer-events: none;
    .icon-matchcenter-right-arrow{
      display: none;
    }
  }
  ${props => props.disableLink && css`
    pointer-events: none !important;
    cursor: default !important;
  `
}
`;



// WEBPACK FOOTER //
// ./src/components/CalendarRow/styles.js